import styled, { css } from 'styled-components';
import { animated } from 'react-spring';

interface ContainerProps {
  type?: 'success' | 'danger' | 'info';
}

const toastTypesVariations = {
  info: css`
    background: #ebf8ff;
    color: #3172b7;
  `,
  success: css`
    background: #1ee0ac;
    color: #fff;
  `,
  danger: css`
    background: #fddede;
    color: #c53030;
  `,
};

export const Container = styled(animated.div)<ContainerProps>`
  width: 370px;

  position: relative;
  padding: 16px 30px 16px 16px;
  border-radius: 4px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);
  cursor: pointer;

  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 320px;
  }

  & + div {
    margin-top: 8px;
  }

  ${props => toastTypesVariations[props.type || 'info']}

  > div {
    width: 100%;

    display: flex;
    align-items: center;

    em {
      font-size: 16px;
      margin-right: 8px;
    }

    svg {
      margin: 0px 12px 0 0;
    }

    div {
      margin-top: 2px;
    }
  }

  > footer {
    width: 100%;
    margin-top: 25px;

    display: flex;
    align-items: center;

    h3 {
      margin-left: 8px;
      font-size: 14px;
    }

    span {
      margin-left: 5px;
      font-size: 12px;
    }
  }
`;
